import {Account, useUpdateAccountMutation} from 'api';
import React, {useEffect, useRef, useState} from 'react';

interface Props {
  account: Account;
}

export default ({account}: Props) => {
  const [updateAccount] = useUpdateAccountMutation({});
  const [establishedYearMonth, setEstablishedYearMonth] = useState(
    account.establishedYearMonth,
  );
  const ref = useRef(null);

  useEffect(() => {
    ref.current.value = account.establishedYearMonth;
  }, [account]);

  return (
    <input
      type="month"
      defaultValue={establishedYearMonth}
      className="w-56 h-7 rounded hover:border hover:border-border focus:border focus:border-border"
      onChange={(e) => setEstablishedYearMonth(e.target.value)}
      onBlur={(e) => {
        updateAccount({
          variables: {
            id: account.id,
            attributes: {
              establishedYearMonth: e.target.value,
            },
          },
        });
      }}
      ref={ref}
    />
  );
};
